import ListaPreciosVentaUpdate from "./ListaPreciosVentaUpdate.vue";
export default ListaPreciosVentaUpdate;
